<template>
    <div class="container">
        <el-row :gutter="20" class="border" v-if="course && user">
            <el-col :span="5" class="infoBorder">
                <!-- 头像 -->
                <img :src="user.avatar" class="avatar">
            </el-col>
            <el-col :span="8" class="infoBorder">
                <!-- 个人信息 -->
                <div class="font_1">用户:{{ user.nickName }}</div> <br>
                <div class="font_1">是否获得学习认证:{{ course.hasCertifica == 1 ? '是' : '否' }}</div> <br>
                <div class="font_1">加入时间:{{ course.joinTime }}</div> <br>
            </el-col>
            <el-col :span="7" class="infoBorder" v-if="course.hasCertifica == 1">
                <!-- 学习认证 -->
                <span class="font_1">学习认证</span>
                <img :src="applyCertifica.link" class="certifica">
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="course.hasCertifica == 1">
                 <el-button type="danger" class="cBtn" @click="reApply(applyCertifica.link)" plain>重新申请</el-button>
                 <el-button type="warning" class="cBtn" @click="download(applyCertifica.link)" plain>下载证书</el-button>
            </el-col>

            <el-col :span="7" class="infoBorder" v-if="course.hasCertifica != 1">
                <!-- 学习认证 -->
                <span class="font_1">学习认证模版</span>
                <img src="@/assets/img/card/certificate.jpg" class="certifica">
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="course.hasCertifica == 2">
                 <el-button type="warning" class="cBtn" plain>审核中</el-button>
            </el-col>
            <el-col :span="3" class="infoBorder" v-if="course.hasCertifica == 0">
                 <el-button type="success" class="cBtn" @click="addCertifica()" plain>立即申请</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="border">
            <el-col :span="14" class="infoBorder">
                <div class="font_3">以下数据每天24点更新</div>
                <div class="font_3">最近一场考试</div>
                <div id="preScore" class="preScore" ></div>
            </el-col>

            <el-col :span="9" class="infoBorder" >
                <el-row :gutter="20">
                    <el-col :span="11" class="infoBorder">
                        <div id="homeworkEchart" class="homeworkEchart" ></div>
                    </el-col>
                    <el-col :span="11" class="infoBorder">
                        <div id="examEchart" class="examEchart" ></div>
                    </el-col>
                    <div id="progress" class="progress2" ></div>
                </el-row>
            
            </el-col> 
        </el-row>

        <el-row :gutter="20" class="border">
            <el-col :span="24" class="infoBorder">
                <div id="homeworkHistory" class="homeworkHistory" ></div>
            </el-col>
        </el-row>
    
        <el-row :gutter="20" class="border">
            <el-col :span="24" class="infoBorder">
                <div id="examHistory" class="examHistory" ></div>
            </el-col>
        </el-row>
    
    
    </div>
    
  </template>
  <script setup>
  import * as echarts from 'echarts';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { ref, onMounted } from "vue";
import {ElMessage, ElMessageBox} from 'element-plus'


const user = ref();
const course = ref();
const applyCertifica = ref();

const token = localStorage.getItem("token");
const Route = useRoute(); //获取到值
   
onMounted(() => {

    pullInfo();

    // 近期成绩分析
    var preScore = echarts.init(document.getElementById('preScore'));

    let preScoreOption = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                type: 'category',
                data: ['总分', '最高分', '最低分', '平均分', '学生分数'],
                axisTick: {
                    alignWithLabel: true
                }
                }
            ],
            yAxis: [
                {
                type: 'value'
                }
            ],
            series: [
                {
                name: '最近一场考试分析',
                type: 'bar',
                barWidth: '60%',
                }
            ]
        };


    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getPreScore",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                preScoreOption.series[0].data = resp.data;
                console.log(resp.data);
                preScore.setOption(preScoreOption);
            }

        },
    });
    
    

    // 作业完成况
    var homeworkEchart = echarts.init(document.getElementById('homeworkEchart'));

    let homeworkEchartOption = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'center'
        },
        series: [
            {
            name: '作业提交状况',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
            },
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            data: []
            }
        ]
    };

    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getExamEchart",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
            type: 0
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                homeworkEchartOption.series[0].data = resp.data;
                    console.log(resp.data);
                homeworkEchart.setOption(homeworkEchartOption);
            }

        },
    });


    var examEchart = echarts.init(document.getElementById('examEchart'));
    let examEchartOption = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'center'
        },
        series: [
            {
            name: '考试参与状况',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
            },
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            data: []
            }
        ]
    };

    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getExamEchart",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
            type: 1
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                examEchartOption.series[0].data = resp.data;
                    console.log(resp.data);
                    examEchart.setOption(examEchartOption);
            }

        },
    });




    var progress = echarts.init(document.getElementById('progress'));

    let progressOption = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'center'
        },
        series: [
            {
            name: '学习进度',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '70%'],
            // adjust the start and end angle
            startAngle: 180,
            endAngle: 360,
            data: []
            }
        ]
    };

    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getDataRecord",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                progressOption.series[0].data = resp.data;
                    // console.log(resp.data);
                    progress.setOption(progressOption);
            }

        },
    });



    var homeworkHistory = echarts.init(document.getElementById('homeworkHistory'));

    let homeworkHistoryOption = {
        title: {
        text: '历史作业成绩'
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['作业成绩', '平均分']
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {
        feature: {
        saveAsImage: {}
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
    },
    yAxis: {
        type: 'value'
    },
    series: [ ]
    };


    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getHistoryScore",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
            type: 0
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                homeworkHistoryOption.series = resp.data.series;
                homeworkHistoryOption.xAxis.data = resp.data.timeList;
                    // console.log(resp.data);
                    homeworkHistory.setOption(homeworkHistoryOption);
            }

        },
    });



    var examHistory = echarts.init(document.getElementById('examHistory'));

    let examHistoryOption = {
        title: {
        text: '历史考试成绩'
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['考试成绩', '平均分']
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {
        feature: {
        saveAsImage: {}
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
    },
    yAxis: {
        type: 'value'
    },
    series: [ ]
    };


    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getHistoryScore",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
            type: 1
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                examHistoryOption.series = resp.data.series;
                examHistoryOption.xAxis.data = resp.data.timeList;
                    // console.log(resp.data);
                    examHistory.setOption(examHistoryOption);
            }

        },
    });
})
  


const pullInfo = () => {
    $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getCertifica",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            userId: Route.params.userId || null,
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                user.value = resp.data.user;
                course.value = resp.data.course;
                if (course.value.hasCertifica == 1) {
                    applyCertifica.value = resp.data.applyCertifica;
                }
            }

        },
    });
}

const addCertifica = () => {

    ElMessageBox.confirm("是否申请学习认证?", "申请学习认证", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/addCertifica",
        type: "post",
        data: {
            courseId: Route.params.courseId
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullInfo();    
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "申请失败! 请稍后再试!"
            });
        }
    });
        
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消申请",
      });
    });
}


const reApply = (link) => {
    ElMessageBox.confirm("是否重新申请学习认证?", "重新申请学习认证", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/reApplyCertifica",
        type: "post",
        data: {
            courseId: Route.params.courseId,
            link: link
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullInfo();    
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "申请失败! 请稍后再试!"
            });
        }
    });
        
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消申请",
      });
    });
}

const download = (link) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
  
  
  </script>

<style scoped>
.avatar {
    width: 200px;
    padding: 20px;
    border-radius: 50%;
    transition: 600ms;
}

.avatar:hover{
    width: 230px;
    border-radius: 20%;
    transition: 600ms;
    cursor: pointer;
}

.font_1 {
    font-size: 20px;
    color: rgb(105, 105, 105);
    font-weight: bold;
    margin: 5px;
}

.certifica {
    width: 400px;
}

.infoBorder {
    margin: 5px;
}

.cBtn {
    float: right;
    margin-top: 80px;
}

.preScore {
    width: 700px;
    height:400px;
}

.homeworkEchart {
    width: 300px;
    height: 200px;
    display: inline;
}

.examEchart {
    width: 300px;
    height: 200px;
}

.progress2 {
    width: 800px;
    height: 200px;
}

.homeworkHistory {
    width: 100%;
    height:400px;
}

.examHistory {
    width: 100%;
    height:400px;
}

.font_3 {
    color: rgb(129, 129, 129);
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 5px;
}
</style>